function removeEmptyFromObject(obj) {
  let newObj = {};
  Object.keys(obj).forEach(key => {
    if (obj[key] === Object(obj[key]) && Object.keys(obj[key]).length) newObj[key] = removeEmptyFromObject(obj[key]);else if (obj[key] !== undefined) newObj[key] = obj[key];
  });
  return newObj;
}
export { removeEmptyFromObject };